<!-- <div class="BackgroundContainer">
<abc-authentication-webapi-editor requiredSystemName="BaSYS" errorClass="greenError">
</abc-authentication-webapi-editor>
</div> -->

<div class="container" [class.mobile]="isMobileVersion">
  @if (!isMobileVersion) {
    <div class="illustration">
      @if(illustration){
        <img
          [src]="illustration"
          (error)="illustration !== fallbackIllustration && (illustration = fallbackIllustration)"
          />
      } @else {
        <ng-content select="[illustration]"></ng-content>
      }
    </div>
  }
  <div class="controls">
    <img [src]="logo" (click)="onLogoClick()" (error)="logo !== fallbackLogo && (logo = fallbackLogo)" />
    <abc-authentication-webapi-editor requiredSystemName="BaSYS" errorClass="greenError">
    </abc-authentication-webapi-editor>
  </div>
</div>
